import { AccountLabel } from "@/entities/Labeling/Account.model";

export const BALANCE_SHEET_CODES: AccountLabel[] = [
    AccountLabel.ASSETS,
    AccountLabel.NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT,
    AccountLabel.CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
    AccountLabel.LIABILITIES,
    AccountLabel.CURRENT_ASSETS_NET_RECEIVABLES,
    AccountLabel.CURRENT_LIABILITIES_ACCOUNTS_PAYABLE,
    AccountLabel.CURRENT_ASSETS_NET_INVENTORY,
    AccountLabel.CURRENT_LIABILITIES_DEBT,
];

export const INCOME_STATEMENT_CODES: AccountLabel[] = [
    AccountLabel.REVENUES,
    AccountLabel.GROSS_MARGIN,
    AccountLabel.EBITDA,
    AccountLabel.EBITDA_MARGIN,
    AccountLabel.NET_INCOME,
    AccountLabel.NET_INCOME_MARGIN,
];
